import { ButtonFixedFooterLayout, ButtonLink, ButtonPrimary, Text1, Text2, Text3, skinVars } from '@telefonica/mistica';
import React, { useState } from 'react';
import './index.scss';
import { t } from 'i18next';
import { hideEmailCharacters, hideMobileCharacters } from '../../utils/dataTransformation/unitsConversion';

export interface OTPVerificationData {
    title: string;
    subtitle1: string;
    subtitle2: string;
    contact: string;
    handleButtonContinue?: any;
    handleSendAgain?: any;
    setOTPValue?: any;
    incorrectCode?: boolean;
    typeVerificationContact?: string;
}

export const OTPVerification: React.FC<OTPVerificationData> = ({
    title,
    subtitle1,
    subtitle2,
    contact,
    handleButtonContinue,
    handleSendAgain,
    setOTPValue,
    incorrectCode,
    typeVerificationContact,
}: OTPVerificationData) => {
    const [buttonState, setButtonState] = useState<boolean>(false);
    const [value] = useState<any>();
    let aux: any = [];
    const keyPressed = (idx: number, event: any) => {
        const input = document.querySelectorAll('.otp-verification__inputs__input');
        if ((input[idx] as any).value.length <= 1) {
            if (event.nativeEvent.inputType === 'deleteContentBackward') {
                if (idx === 0) {
                    (input[idx] as any).focus();
                }
            } else {
                if (idx <= 4) {
                    (input[idx + 1] as any).focus();
                }
            }
            input.forEach((item: any) => {
                aux.push(item.value);
            });
        } else {
            (input[idx] as any).value = (input[idx] as any).value.slice((input[idx] as any).value.length - 1);
        }
        setButtonState(!aux.slice(-6).every((item: string) => item !== ''));
        setOTPValue(aux.slice(-6).join(''));
    };

    const handleLimitInput = (event: any) => {
        return event.target.value.length === 1;
    };

    return (
        <div className='otp-verification'>
            <ButtonFixedFooterLayout
                button={
                    <ButtonPrimary
                        disabled={buttonState}
                        onPress={() => {
                            handleButtonContinue();
                        }}
                    >
                        {t('continue')}
                    </ButtonPrimary>
                }
            >
                <div className='otp-verification__title'>
                    <Text3 regular color={skinVars.colors.textPrimary}>
                        {title}
                    </Text3>
                </div>
                <div className='otp-verification__subtitle'>
                    <Text2 regular color={skinVars.colors.textSecondary}>
                        {subtitle1}{' '}
                        {typeVerificationContact === 'mobile'
                            ? hideMobileCharacters(contact)
                            : hideEmailCharacters(contact)}
                        {subtitle2}
                    </Text2>
                </div>
                <div className='otp-verification__inputs'>
                    {[1, 2, 3, 4, 5, 6].map((digit, idx) => (
                        <input
                            tabIndex={idx}
                            key={idx}
                            type='number'
                            pattern='[0-9]{0,1}'
                            maxLength={1}
                            value={value}
                            onKeyUp={(event) => handleLimitInput(event)}
                            className={
                                incorrectCode
                                    ? 'otp-verification__inputs__input otp-verification__inputs__input__red'
                                    : 'otp-verification__inputs__input'
                            }
                            onChange={(event) => {
                                keyPressed(idx, event);
                            }}
                        />
                    ))}
                </div>
                {incorrectCode && (
                    <div className='otp-verification__helperTextError'>
                        <Text1 regular color={skinVars.colors.error}>
                            {t('contactVerificationOTPhelperTextError')}
                        </Text1>
                    </div>
                )}
                <div className='otp-verification__buttonLink'>
                    <ButtonLink onPress={() => handleSendAgain()}> {t('contactVerificationOTPLink')}</ButtonLink>
                </div>
            </ButtonFixedFooterLayout>
        </div>
    );
};
export default OTPVerification;
